<template>
  <div class="delimiter-tag-input form-control form-control-solid" @click="focusInput">
    <span
        v-for="(tag, index) in tags"
        :key="`${tag}-${index}`"
        class="delimiter-tag"
    >
      <span class="delimiter-tag__label">{{ tag }}</span>
      <button
          type="button"
          class="delimiter-tag__remove"
          tabindex="-1"
          aria-label="Remover"
          @click.stop="removeTag(index)"
      >
        ×
      </button>
    </span>
    <input
        ref="input"
        v-model="draft"
        type="text"
        class="delimiter-tag-input__field"
        :placeholder="tags.length === 0 ? placeholder : ''"
        @keydown="onKeydown"
        @input="onInput"
        @blur="commitDraft"
        @paste="onPaste"
    >
  </div>
</template>

<script>
export default {
  name: "DelimiterTagInput",
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: 'Digite e pressione vírgula, ponto e vírgula ou Enter',
    },
  },
  data() {
    return {
      draft: '',
    };
  },
  computed: {
    tags() {
      return Array.isArray(this.modelValue) ? this.modelValue : [];
    },
  },
  methods: {
    focusInput() {
      this.$refs.input?.focus();
    },
    onKeydown(event) {
      if (event.key === 'Enter' || event.key === ',' || event.key === ';') {
        event.preventDefault();
        this.commitDraft();
        return;
      }

      if (event.key === 'Backspace' && !this.draft && this.tags.length > 0) {
        this.removeTag(this.tags.length - 1);
      }
    },
    onInput() {
      if (!/[;,]/.test(this.draft)) {
        return;
      }

      const parts = this.draft.split(/[;,]/);
      const pending = parts.pop() ?? '';

      parts
          .map((item) => item.trim())
          .filter((item) => item.length > 0)
          .forEach((item) => this.addTag(item));

      this.draft = pending;
    },
    onPaste(event) {
      event.preventDefault();
      const text = event.clipboardData?.getData('text') ?? '';
      if (!text) {
        return;
      }

      const parts = text
          .split(/[;,]/)
          .map((item) => item.trim())
          .filter((item) => item.length > 0);

      const next = [...this.tags];
      parts.forEach((item) => {
        if (!next.includes(item)) {
          next.push(item);
        }
      });

      this.$emit('update:modelValue', next);
      this.draft = '';
    },
    commitDraft() {
      const value = this.draft.trim();
      if (value) {
        this.addTag(value);
      }
      this.draft = '';
    },
    addTag(value) {
      if (!value || this.tags.includes(value)) {
        return;
      }

      this.$emit('update:modelValue', [...this.tags, value]);
    },
    removeTag(index) {
      const next = [...this.tags];
      next.splice(index, 1);
      this.$emit('update:modelValue', next);
    },
  },
};
</script>

<style scoped>
.delimiter-tag-input {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.4rem;
  min-height: calc(1.5em + 1.1rem + 2px);
  height: auto;
  padding: 0.4rem 0.65rem;
  cursor: text;
}

.delimiter-tag-input__field {
  flex: 1 1 8rem;
  min-width: 8rem;
  border: none;
  outline: none;
  background: transparent;
  padding: 0.15rem 0;
  font-size: inherit;
  line-height: 1.5;
}

.delimiter-tag {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  max-width: 100%;
  padding: 0.15rem 0.35rem 0.15rem 0.55rem;
  background: #f1f3f8;
  border: 1px solid #e4e6ef;
  border-radius: 0.425rem;
  font-size: 0.9rem;
  line-height: 1.4;
}

.delimiter-tag__label {
  word-break: break-word;
}

.delimiter-tag__remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.1rem;
  height: 1.1rem;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: #7e8299;
  font-size: 1rem;
  line-height: 1;
  cursor: pointer;
}

.delimiter-tag__remove:hover {
  background: #e4e6ef;
  color: #3f4254;
}
</style>
